import { createContext, useState } from "react";

const UserContext = createContext(null);
console.log(UserContext);
export const UserContextProvider = ({ children }) => {
  console.log("userContext called");
  const [userRole, setUserRole] = useState(sessionStorage.getItem("userRole"));
  const [userName, setUserName] = useState(sessionStorage.getItem("Name"));
  const [userId, setUserId] = useState(sessionStorage.getItem("UserID"));
  const [accessToken, setAccessToken] = useState();
  const [passChangeRequired, setPassChangeRequired] = useState();
  const [isPresenter, setIsPresenter] = useState(
    sessionStorage.getItem("isPresenter")
  );
  console.log(accessToken);
  return (
    <UserContext.Provider
      value={{
        userRole,
        setUserRole,
        userName,
        setUserName,
        userId,
        setUserId,
        accessToken,
        setAccessToken,
        passChangeRequired,
        setPassChangeRequired,
        isPresenter,
        setIsPresenter,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
